import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseService } from '../../shared/services/base.service';
// import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';

@Component({
    selector: 'kx-view-resource',
    templateUrl: './view-resource.component.html',
    styleUrls: ['./view-resource.component.scss'],
    standalone: false
})
export class ViewResourceComponent implements OnInit {
  // public editorOptions: JsonEditorOptions;
  // @ViewChild('editor') editor: JsonEditorComponent;
  id;
  data: any;
  resource: any;
  constructor(private activatedRoute: ActivatedRoute,
    private baseService: BaseService,
    private router: Router,
    private location: Location) {
    // this.editorOptions = new JsonEditorOptions();
    // this.editorOptions.modes = ['code', 'text', 'tree', 'view']; // set all allowed modes
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id;
    this.getResourceNameById(this.id);    
  }

  getResourceNameById(id) {
    try {
      this.baseService.getById(id, 'resource_master').subscribe(res => {
        this.resource = res.resource_name;
        this.getResourceDef(this.resource);
      })
    } catch(e) {
      console.error('Error while getting Resource Name ', e);
    }
  }

  getResourceDef(resourceName) {
    try {
      this.baseService.getResourceDef(resourceName, (resDef) => {
        this.data = resDef; //assigning resource definition to component
      })
    } catch(e) {
      console.error('Error in assigning resource ', e);
    }
  }

  getData(event) {
    console.log('changes in json editor ==>>', event);
  }

  goBack() {
    this.location.back(); //going back location
  }

}
